<script>
	/*
		TCareRatingStars.svelte

		A set of five stars - may need to make them comps.

		A star is clickable and also shows its value.
		Colors are passed in via the starColor prop.

		Usage:
		
            <TCareRatingStars 
                source={item} 
                prop={'average-rating'} 
                setValue={null}
                isReadOnly={true}
                starColor={STAR_COLOR}
            />
	*/

    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiStar, mdiStarOutline } from '@mdi/js';

	const STAR_VALUES = [1, 2, 3, 4, 5];				// only for iterating HTML below
	
	export let source;
	export let prop;
	export let setValue;
	export let isReadOnly;
	export let starColor;
	
	$: value = source[prop];
	$: iconStyle = 'fill: ' + starColor + ';';

	const _onStarClick = (val) => {
		if (isReadOnly) return;
		if (!setValue) return;
		setValue(source, prop, val);
		value = val;		// in case the source does not get refreshed
	}

</script>

<style>

	.rating-stars {
		width: fit-content;
		align-items: center;
		/* border: 1px solid red; */
	}

	.rating-stars .rating-star {
		margin-right: 0px;
	}

	:global(.rating-stars .rating-star svg) {
		width: 18px;
		height: 18px;
		margin-right: 0px;
    	margin-top: 5px;
		fill: var(--tcui-secondary);
		/* fill: {starColor}; */
		outline: none;
	}

</style>

<!-- the correct way would be to use TCareRatingStar components! but this woks too -->

<div class="tcui-control flex-row rating-stars">
	{#each STAR_VALUES as val}
		<div class="rating-star" on:click={() => _onStarClick(val)}>
			{#if value >= val}
				<Icon component={Svg} viewBox="0 0 24 24" style={iconStyle}><path d={mdiStar} /></Icon>
			{:else}
				<Icon component={Svg} viewBox="0 0 24 24" style={iconStyle}><path d={mdiStarOutline} /></Icon>
			{/if}
		</div>
	{/each}
</div>
